import React, { useContext } from 'react';
import CanvasCard from '../../Visualisations/CanvasCard';
import { ChartTopBar } from '../../Chart';
import StackedAreaContent from './StackedAreaContent';
import DashboardGadgetBottomBar from '../../DashboardGadgetBottomBar';
import DashboardGadgetContext from '../../../contexts/DashboardGadgetContext';

const StackedArea = ({
  chartDefinition,
  chartRef,
}: {
  chartDefinition: V5ChartDefinition;
  chartRef: React.MutableRefObject<any>;
}) => {
  const { dashboardGadget } = useContext(DashboardGadgetContext);

  return (
    <CanvasCard
      topBar={<ChartTopBar chartDefinition={chartDefinition} />}
      content={
        <StackedAreaContent
          chartDefinition={chartDefinition}
          chartRef={chartRef}
        />
      }
      bottomBar={dashboardGadget ? <DashboardGadgetBottomBar /> : undefined}
    />
  );
};

export default StackedArea;
